import React from 'react';

/**
 * Reusable card component for Account/Profile settings
 * Matches homepage card styling with soft shadows and rounded corners
 */
const AccountCard = ({ title, subtitle, children, className = '', headerAction }) => (
  <div className={`account-card ${className}`}>
    {(title || headerAction) && (
      <div className="account-card-header">
        <div>
          {title && <h2 className="account-card-title">{title}</h2>}
          {subtitle && <p className="account-card-subtitle">{subtitle}</p>}
        </div>
        {headerAction && <div className="account-card-action">{headerAction}</div>}
      </div>
    )}
    {children}
  </div>
);

export default AccountCard;
